import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {ApplicationEventService} from '~shared/modules/application-event/services';
import {MiniCartApplicationEvent} from '~shared/modules/application-event/models/mini-cart-application-event.model';
import {ApplicationMiniCartEventTypeEnum} from '~shared/modules/application-event/constants';
import {GaTrackingEventLabel} from '~shared/modules/ga-tracking/constants';

@Component({
  selector: 'app-mini-shopping-cart-empty',
  templateUrl: './mini-shopping-cart-empty.component.html',
  styleUrls: ['./mini-shopping-cart-empty.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MiniShoppingCartEmptyComponent {
  @Output()
  closeCart: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  expanded: boolean;
  @Input()
  deleteFlag: boolean;
  @Input()
  undoCart: boolean;
  @Input()
  catalogRoute: string;
  @Input()
  queryParams;

  constructor(private applicationEventService: ApplicationEventService) {}

  trackGoToPromotionsClick() {
    this.applicationEventService.publish(
      new MiniCartApplicationEvent(
        ApplicationMiniCartEventTypeEnum.GoToPromotionsClicked,
        GaTrackingEventLabel.FromMiniCart
      )
    );
    this.closeCart.emit();
  }
}
